<template lang="html">
  <div class="notice_content">
    <div class="divider_line"><span>相关产品</span></div>
    <div class="list_div">
        <Table
          :columns="columns"
          :data="list"
          v-if="list.length > 0">
        </Table>
        <!-- <div class="page clear" v-if="total > 10">
            <Page :total="total" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
        </div> -->
        <OrgPrompt which="cpxxgs" v-if="list.length > 5"></OrgPrompt>
    </div>
    <Nothing v-if="list.length == 0 && !spinShow">
      <p>暂无相关产品</p>
    </Nothing>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { productList } from '../../../service'
import filter from 'js/filter'
import Nothing from '@/components/Nothing2'
import OrgPrompt from '@/components/OrgPrompt'
import { get_meta } from 'js/get_meta'
export default {
  mixins: [get_meta],
  data() {
    return {
      spinShow: true,
      list: [],
      total: 0,
      params: {
        entity_uid: this.$route.params.uid,
        // entity_uid: 'e492679047ee11ea813927e752ff12da'
      },
      columns: [
        {title: '产品名称',width: 420,render: (h, params) => {
            return h('span',filter.empty(params.row.title))
          }
        },
        {title: '产品类型',Width: 210,render: (h, params) => {
            return h('div',{class: {vertical: true}},filter.dealNeed(params.row.product_type_id, this.meta.product_type))
          }
        },
        {title: '审批机构',width: 170,render: (h, params) => {
            return h('span',filter.empty(params.row.approval_org))
          }
        },
        {title: '获批时间',width: 160,render: (h, params) => {
            return h('span',filter.timeTrans(params.row.approval_time))
          }
        }
      ]
    }
  },
  components: {
    Nothing, OrgPrompt
  },
  methods: {
    async getDetail() {
      let res = await productList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'list', res.res)
        if(this.list.length > 0) this.$emit('callbackData', 'Product')
        this.spinShow = false;
      } else {
        this.$Message.error(res.msg)
      }
      this.$nextTick(() => {this.spinShow = false})
    },
    handlePage(page) {
      this.params.page = page
      this.getDetail()
    }
  },
  created() {
    this.getMeta(['product_type'])
    this.getDetail()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.notice_content
  padding: 32px
  .divider_line
    margin: 0 0 32px
  .list_div
    padding: 0 18px
.ivu-table-wrapper >>> a.upload_ico
  color: rgba(250, 122, 80, 1)
  .iconfont
    display: inline-table
    vertical-align: top
    font-size: 14px
    margin-right: 4px
</style>
